import { DocumentNode, gql } from '@apollo/client';
import { Text } from '@chakra-ui/react';
import { dinero, greaterThan, isZero, maximum, minimum } from 'dinero.js';

import { CurrencyDisplay } from '@/components/Currency';
import { useDefaultCurrency } from '@/hooks/useDefaultCurrency';
import { Semibold } from '@/imports/ui/chakra/components/Semibold';

import { TicketsAvailable_EventFragmet } from './graphql-types/TicketsAvailable_EventFragmet';

export const TicketsAvailableMessage: React.FC<{
  event: TicketsAvailable_EventFragmet;
  useLearningRegistrationCopy?: boolean;
}> & { eventFragment: DocumentNode } = ({
  event,
  useLearningRegistrationCopy = false,
}) => {
  const { currency } = useDefaultCurrency();

  const ticketPrices = event.ticketsCurrentUserCanPurchase.map((ticket) =>
    dinero(ticket.price)
  );

  const minTicketPrice = ticketPrices.length
    ? minimum(ticketPrices)
    : dinero({ amount: 0, currency });

  const maxTicketPrice = ticketPrices.length
    ? maximum(ticketPrices)
    : dinero({ amount: 0, currency });

  return (
    <Text>
      {useLearningRegistrationCopy
        ? 'Enrollment is available:'
        : 'Tickets are available:'}{' '}
      {!greaterThan(maxTicketPrice, minTicketPrice) &&
      isZero(minTicketPrice) ? (
        <Semibold>Free</Semibold>
      ) : (
        <CurrencyDisplay value={minTicketPrice} fontWeight="semibold" />
      )}
      {greaterThan(maxTicketPrice, minTicketPrice) && (
        <>
          {' '}
          - <CurrencyDisplay value={maxTicketPrice} fontWeight="semibold" />
        </>
      )}
    </Text>
  );
};

TicketsAvailableMessage.eventFragment = gql`
  fragment TicketsAvailable_EventFragmet on EventV2 {
    _id
    ticketsCurrentUserCanPurchase {
      _id
      price
    }
  }
`;
